/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatLoadOverview } from "../funcs/chatLoadOverview.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ChatOverview } from "../models/components/chatoverview.js";
import {
  LoadChatOverviewRequest,
  LoadChatOverviewSecurity,
} from "../models/operations/loadchatoverview.js";
import { unwrapAsync } from "../types/fp.js";
export type LoadChatOverviewQueryData = ChatOverview;

export function prefetchLoadChatOverview(
  queryClient: QueryClient,
  client$: GramCore,
  request: LoadChatOverviewRequest,
  security?: LoadChatOverviewSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildLoadChatOverviewQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildLoadChatOverviewQuery(
  client$: GramCore,
  request: LoadChatOverviewRequest,
  security?: LoadChatOverviewSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<LoadChatOverviewQueryData>;
} {
  return {
    queryKey: queryKeyLoadChatOverview({
      id: request.id,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
      gramChatSession: request.gramChatSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function loadChatOverviewQueryFn(
      ctx,
    ): Promise<LoadChatOverviewQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(chatLoadOverview(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyLoadChatOverview(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
    gramChatSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "chat", "loadOverview", parameters];
}
